import { render, staticRenderFns } from "./AppLeadCard.vue?vue&type=template&id=3596b175&"
import script from "./AppLeadCard.vue?vue&type=script&lang=js&"
export * from "./AppLeadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports